import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground outline-none focus:outline-none focus-visible:outline-none focus:ring-2 focus:ring-[#38BDF8]/30 focus:border-[#38BDF8] focus-visible:ring-2 focus-visible:ring-[#38BDF8]/30 focus-visible:border-[#38BDF8] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
